import { AppButton, AppTextField } from 'components';
import { memo, useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { ReactSortable } from 'react-sortablejs';
import Editor from 'components/CKEditor/Editor';
import { getRandomUid } from 'utilities/uuid.service';
import DOMPurify from 'dompurify';
import * as AppPics from 'assets/images';
import { EditorPreviewContext } from 'context/EditorPreviewContext';
// import HandleDelete from '../HandleDelete';
import useDebounce from 'hooks/useDebounce';
import QuizSectionsSettings from './QuizSectionsSettings';
import useQueryParams, { QueryParamsAsString } from 'hooks/useQueryParams';
import { removeHtmlTags } from 'utilities/fns';

function FillInTheBlanks({ editMode, handleSave, data, toggleView, configs = {} }) {
  const history = useHistory();
  const { quizID, courseID, chapterID, classID } = useParams();
  const { PreviewBtn } = useContext(EditorPreviewContext);

  const queryParams = useQueryParams();
  const paperId = queryParams.get('paperId');

  const queryString = QueryParamsAsString();

  const [showForm, toggleShowForm] = toggleView ?? [];
  const { hideSaveBtn = false, hideTopBtnSection = false, deleteConfig, showRating } = configs;

  const [section, setSection] = useState();

  const [hint, setHint] = useState('');
  const [explanation, setExplanation] = useState('');
  const [marks, setMarks] = useState('');

  const [options, setOptions] = useState([{ id: getRandomUid(), option: '' }]);
  const [title, setTitle] = useState('');
  const [qStatus, setQStatus] = useState('active');

  const [settings, setSettings] = useState({});

  useEffect(() => {
    if (data?.data) {
      setTitle(DOMPurify.sanitize(data?.data?.title) || '');
      setQStatus(data?.data?.status || 'active');
      setOptions(
        data?.data?.fillOptions?.map?.((x) => ({
          id: getRandomUid(),
          option: DOMPurify.sanitize(x),
        })) || []
      );
      setHint(data?.data?.hint ?? '');
      setExplanation(data?.data?.explanation ?? '');
      setMarks(data?.data?.marks ?? '');
      setSection(data?.data?.sectionId ?? '');

      const __settings = {
        difficultyLevel: data?.data?.difficultyLevel,
        assessmentObjective: data?.data?.assessmentObjective,
        examBoard: data?.data?.examBoard,
        askedInYear: data?.data?.askedInYear,
      };
      setSettings((x) => ({ ...x, ...__settings }));
    }
  }, [data?.data]);

  function handleQuizQuestion(quizFormData = {}) {
    if (!title) {
      window.alert('Please specify the question');
      return;
    }
    if (options.length <= 0) {
      window.alert('Please specify the options');
      return;
    }

    handleSave(quizFormData);
  }

  const [currentEdited, updateCurrentEditBlock] = useState({});

  const editorData = useDebounce(currentEdited, 100);

  useEffect(() => {
    if (editorData.id) {
      updateCurrentEditBlock(editorData);
      setOptions(
        options.map((x) => {
          if (x.id === editorData.id) x.option = editorData.data;
          return x;
        })
      );
    }
  }, [editorData]);
  return (
    <div className="tab__content-actBody">
      <div className="px-5">
        {!hideTopBtnSection && (
          <div className="row justify-content-end my-4 ">
            <div className="col-12">
              {!editMode && (
                <AppButton
                  variantClass="btn-plane p--tint mx-2"
                  onClick={() => {
                    setOptions([]);
                    setQStatus('active');
                    setTitle('');
                    toggleShowForm(!showForm);
                  }}
                >
                  Change question type
                </AppButton>
              )}
              <AppButton
                variantClass="btn-plane mx-2"
                onClick={() => {
                  history.push(
                    `/classes/${classID}/courses/${courseID}/chapters/${chapterID}/quizzes/${quizID}/questions${queryString}`
                  );
                }}
              >
                Back to questions list
              </AppButton>
            </div>
          </div>
        )}

        <div className="row mt-4">
          <div className="col-md-12 col-lg-12 col-sm-12">
            <div className="lessonWrap lessonWrap--border topalign __fill__up__blanks">
              <div className="my-4">
                <div className="w-100 p-3">
                  <QuizSectionsSettings
                    selectedItemId={section}
                    selectedPaperId={paperId}
                    handleChange={(id) => setSection(id)}
                    prefix={'fibQs' + data?.data?._id}
                    extras={{
                      settings,
                      setSettings: (item = {}) => setSettings((x) => ({ ...x, ...item })),
                    }}
                  />
                </div>
              </div>
              <div className="w-100 p-3">
                <label htmlFor="questionToFill">Question</label>
                {title && <PreviewBtn block={{ value: title }} />}
                <Editor
                  data={{
                    value: title,
                    onChange: (data) => setTitle(data),
                  }}
                  config={{
                    placeholder: 'Enter only the question here.',
                  }}
                />
              </div>

              <div className="col-12">
                <label htmlFor="questionToFill">
                  Add the correct choices in order as per the blanks.
                </label>
              </div>
              <ReactSortable list={options} setList={setOptions} handle=".grabHandleID">
                {options.map((choice, index) => {
                  return (
                    <div className="lessonWrap  topalign py-0 grabHandleID" key={choice.id}>
                      <div className="w-100 p-3">
                        <label htmlFor="">Choice #{index + 1}</label>
                        <AppButton
                          variantClass="lessonWrap__btn leftpos dublicate"
                          title="Clone"
                          onClick={() => {
                            setOptions(
                              options.concat({
                                id: getRandomUid(),
                                option: choice.option,
                              })
                            );
                          }}
                        >
                          <img src={AppPics.StampSvg} alt="clone this option" />
                        </AppButton>
                        <AppButton
                          variantClass="lessonWrap__btn leftpos delete"
                          onClick={() => {
                            setOptions(options.filter((x) => x.id !== choice.id));
                          }}
                        >
                          <img src={AppPics.DeleteSvg} alt="delete this option" />
                        </AppButton>
                        {choice.option && <PreviewBtn block={{ value: choice.option }} />}
                        <AppTextField
                          labelProps={{ label: ' ' }}
                          inputProps={{
                            placeholder: 'Please provide your choice here',
                            value: choice.option,
                            onChange: (event) => {
                              setOptions(
                                options.map((x) => {
                                  if (x.id === choice.id) x.option = event.target.value;
                                  return x;
                                })
                              );
                            },
                          }}
                        />
                      </div>
                    </div>
                  );
                })}
              </ReactSortable>

              <div className="col-12">
                <AppButton
                  variantClass="btn-plane p--tint m-l-btn"
                  onClick={() => {
                    setOptions(
                      options.concat({
                        id: getRandomUid(),
                        option: '',
                        isCorrect: false,
                      })
                    );
                  }}
                >
                  + Add Choice
                </AppButton>
              </div>

              <div className="w-100 p-3 mt-4">
                <label htmlFor="">Hint</label>
                {hint && <PreviewBtn block={{ value: hint }} />}
                <Editor
                  data={{
                    value: hint,
                    onChange: (data) => setHint(data),
                  }}
                />
              </div>
              <div className="w-100 p-3">
                <label htmlFor="">Explanation</label>
                {explanation && <PreviewBtn block={{ value: explanation }} />}
                <Editor
                  data={{
                    value: explanation,
                    onChange: (data) => setExplanation(data),
                  }}
                />
              </div>

              <div className="w-100 p-3">
                <AppTextField
                  labelProps={{ label: 'Marks' }}
                  inputProps={{
                    placeholder: 'Please provide the maximum marks allocated',
                    value: marks || '',
                    onChange: (event) => setMarks(event.target.value),
                  }}
                />
              </div>
            </div>
          </div>

          {/* {!hideSaveBtn && ( */}
          {!showRating && (
            <div className="mb-5 btnTab-foot mt-5">
              <AppButton
                className={`btn-right-content ${!hideSaveBtn ? 'save' : 'btn-plane'}`}
                onClick={() => {
                  handleQuizQuestion({
                    title,
                    fillOptions: options.map((x) => removeHtmlTags(x.option)),
                    status: qStatus,
                    questionType: 'fill',
                    hint,
                    explanation,
                    marks,
                    section,
                    ...settings,
                  });
                }}
              >
                {!hideSaveBtn ? 'Save Changes' : 'Save'}
              </AppButton>
              {/* {deleteConfig?.showBtn && <HandleDelete handleDelete={deleteConfig?.handleDelete} />} */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default memo(FillInTheBlanks);
